/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './welcome-political-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-welcome-political-page',
  template
})
export class WelcomePoliticalPageComponent {
}
